import { EditorAPIKey, EditorCoreApiKey } from '#packages/apis';
import { BaseEntryScope } from '#packages/apilib';

export class BranchesManagerScope extends BaseEntryScope {
  editorCoreAPI = this.useDependency(EditorCoreApiKey);
  editorAPI = this.useDependency(EditorAPIKey);
}
